import React from 'react';
import { Typography } from '@material-ui/core';

import stageClipIcon from 'assets/stageClipIcon.svg';
import { useStyles } from './studentLoginInstitutionHeader.styles';
import { Image } from 'shared/components';
import { StudentLoginInstitutionHeaderProps } from './studentLoginInstitutionHeader.types';
import { useLocale } from 'shared/hooks';

export const StudentLoginInstitutionHeader = ({ isText }: StudentLoginInstitutionHeaderProps) => {
  const styles = useStyles();

  const onRedirectSubmit = () => {
    const supportURL = 'https://stageclip.com/student-support/';
    window.open(supportURL, '_blank');
  };
  const { formatMessage } = useLocale();

  return (
    <div className={styles.container}>
      <div>
        <Image className={styles.logoImage} alt="" src={stageClipIcon} />
      </div>

      {isText ? (
        <Typography className={styles.supportText} onClick={onRedirectSubmit}>
          {formatMessage({
            id: 'studentSelection.clip.final.success.support.text',
          })}
        </Typography>
      ) : (
        <Typography className={styles.supportText} onClick={onRedirectSubmit}>
          Support
        </Typography>
      )}
    </div>
  );
};
